import { ThemeColors } from '../../../../tokens/colors/types';
import edColors from './ED';
import { blue, green, neutral, orange, purple, red } from './palette';
import { deals } from './product';
import { critical, info, positive, warning } from './semantic';

const primary = {
  '50': '#006D85',
  '10': '#F2FCFF',
  '20': '#E5FAFF',
  '30': '#63CCE3',
  '70': '#005466',
  '90': '#004352',
};

// TODO: This colors should be defined. For backward-compatibility they are the same as eDreams but it's wrong.
const secondary = edColors.secondary;

const baseColors: ThemeColors = {
  blue,
  green,
  red,
  orange,
  primary,
  secondary,
  purple,
  neutral,
  info,
  warning,
  critical,
  positive,
  deals,
};

export default baseColors;
